module.exports = __webpack_public_path__ + "img/laser-turrets.c90dbaea.png";